export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5188.3668db07.jpg";